import React, { useState, useEffect } from "react";
import { getById } from "../../actions/generic-actions";
import ModalConfirm from "../../utils/form/modalConfirmBase";
import { updateCharge } from "../../actions/charge-actions";
import ConfirmDialog from "../../utils/form/confirmDialog";
import { useForm } from "react-hook-form";
import { withRouter } from "react-router-dom";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  Button,
  FormHelperText,
  MenuItem,
} from "@material-ui/core";
import { yupResolver } from "@hookform/resolvers/yup";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getState } from "../../actions/dummy-actions";
import { REQUIRED_MESSAGE } from "../../constants";
import { styles } from "../styles";
import * as yup from "yup";

export const STATE = getState();
const Charges = ({
  id,
  stateFieldEdit,
  refresh,
  chargesActive,
  closeOpenEdit,
}) => {
  const classes = styles();
  const [fieldToEdit, setFieldToEdit] = useState(true);
  // const [chargesActive, setChargesActive] = useState([]);
  //const [valuesFind, setValuesfind] = useState([]);
  const [onsubmitDisabled, setOnsubmitDisabled] = useState(false);
  const [charge, setCharge] = useState({
    denomination: "",
    code: "",
    status: "",
    approvers: [],
  });
  const [valueName, setValueName] = useState({});
  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
  });

  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });

  stateFieldEdit(fieldToEdit);

  const schema = yup.object().shape({
    denomination: yup
      .string()
      .required(REQUIRED_MESSAGE)
      .min(5, "Ingrese mínimo 5 caracteres")
      .max(60, "Ingrese máximo 60 caracteres"),
    status: charge.status
      ? null
      : yup.string().nullable().required(REQUIRED_MESSAGE),
    approvers: yup.string(),
  });

  const {
    register,
    handleSubmit,
    setValue,
    errors,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      denomination: charge.denomination,
    },
    mode: "onTouched",
    reValidateMode: "onChange",
  });

  const cancelConfirm = () => {
    setMessage({
      description: "¿Está seguro que NO desea continuar editando el registro?",
      textButtonSubmit: "Aceptar",
      handleClick: () => closeOpenEdit(false),
      handleClickOut: () => handleClickClose(),
      type: "WARNING",
      open: true,
    });
  };

  useEffect(() => {
    const getCharge = async () => {
      const chargeResponse = await getById(id, "/charge/");
      const fields = ["denomination", "code", "status"];
      fields.forEach((field) => setValue(field, chargeResponse.data[field]));

      if (chargeResponse?.data?.chargeApprovers) {
        const approversList = chargeResponse?.data?.chargeApprovers;
        const approvers = [];
        approversList.map((x) => {
          const item = chargesActive.find((c) => c?.id === x.id);
          if (item) approvers.push(item);
        });

        chargeResponse.data["approvers"] = approvers;
      } else {
        chargeResponse.data["approvers"] = [];
      }
      setCharge(chargeResponse.data);
      setValueName(chargeResponse.data.denomination);
    };
    getCharge();
  }, []);

  const changeState = () => {
    setCharge({...charge, 'status' : 'Activo'});
    handleClickClose();
  }

  const onChangeValues = (e) => {
    const { name, value } = e.target;
    
    if(name=== 'status' && value === 'Inactivo' ){
      setMessage({
        description : `Al inactivar se cerrarán las requisiciones que solicitan el cargo ${valueName} y las vacantes publicadas a partir de ellas`,
        textButtonSubmit : 'Aceptar',
        handleClick : () => handleClickClose(),
        handleClickOut: () => changeState(),
        type : 'WARNING',
        open : true
      });
     
    };
    setCharge({ ...charge, [name]: value });
  };

  //const handleClickOut = () => setMessage({ ...message, open: false });
  const handleClickClose = () => {
    setMessage({ ...message, open: false });
    setOnsubmitDisabled(false);
  };

  const onSubmit = (info) => {
    const body = {
      id: id,
      denomination: info.denomination,
      approvers: charge.approvers
        .map(function (item) {
          return item["id"];
        })
        .join(","),
      status: charge.status,
      userEdit: "DEVELOPER",
      creationUser: charge.creationUser,
    };
    setOnsubmitDisabled(true);
    setMessage({
      description: "¿Está seguro que desea actualizar el registro? ",
      textButtonSubmit: "Aceptar",
      handleClick: () => handleClick(body),
      handleClickOut: () => handleClickClose(),
      type: "WARNING",
      open: true,
    });
  };

  const closeModalAndRefrehs = () => {
    refresh();
    setFieldToEdit(false);
    setOnsubmitDisabled(true);
    handleClickClose();
    closeOpenEdit(false);
  };

  const handleClick = (data) => {
    setMessage({ ...message, open: false });

    const user = { userEdit: "DEVELOPER", status: charge.status };
    const idCharge = { id: id };
    const newData = { ...data, ...user, ...idCharge };

    setTimeout(() => {
      const edit = async () => {
        const response = await updateCharge(newData);

        if ((response && response.status === 200) || response.status === 201) {
          setMessage({
            description: `Cargo actualizado exitosamente`,
            textButtonSubmit: "Aceptar",
            handleClick: () => closeModalAndRefrehs(),
            oneButtons: true,
            type: "SUCCESS",
            open: true,
          });
        } else {
          setMessage({
            //solucion mensaje error
            description: response?.data?.detail
              ? response?.data?.detail
              : `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
            textButtonSubmit: "Aceptar",
            handleClick: () => handleClickClose(),
            type: "WARNING",
            open: true,
          });
          setOnsubmitDisabled(false);
        }
      };
      edit();
    }, 1000);
  };

  return (
    <>
      <ConfirmDialog
        open={confirm.open}
        body={confirm.question}
        handleClickOut={confirm.handleClickOut}
        handleClick={confirm.handleClick}
      />
      <form onSubmit={handleSubmit(onSubmit)} style={{ marginLeft: "2%" }}>
        <Grid
          container
          spacing={3}
          alignItems="center"
          style={{ display: "flex", justifyContent: "space-evenly" }}
        >
          <Grid item xs={12} md={6} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                onChange={onChangeValues}
                label="Nombre"
                className={classes.dropdownMultiple}
                name="denomination"
                margin="normal"
                required
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("denomination") &&
                  errors["denomination"].message
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("denomination") &&
                  errors["denomination"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <FormControl fullWidth style={{ marginTop: 15 }}>
              <Autocomplete
                multiple
                name="approvers"
                value={charge.approvers}
                options={charge.approvers.length === 5 ? [] : chargesActive}
                className={classes.dropdownMultiple}
                onChange={(e, newval, reason) => {
                  setCharge({ ...charge, approvers: newval });
                }}
                // error={valueTypeDocument }
                getOptionLabel={(option) => option?.denomination}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    inputRef={register}
                    name="approvers"
                    label="¿Quién aprueba?"
                    InputLabelProps={{ shrink: true }}
                    placeholder="¿Quién aprueba?"
                    error={
                      errors.hasOwnProperty("approvers") &&
                      errors["approvers"].message
                    }
                    helperText={
                      errors.hasOwnProperty("approvers") &&
                      errors["approvers"].message
                    }
                  />
                )}
              />
              <FormHelperText>
                {errors.hasOwnProperty("approvers") &&
                  errors["approvers"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              error={
                !!errors.hasOwnProperty("status") && errors["status"].message
              }
            >
              <InputLabel htmlFor="outlined-select-estado" shrink={true}>
                Estado *
              </InputLabel>
              <Select
                className={classes.dropdownMultiple}
                inputRef={register}
                label="Estado *"
                onChange={onChangeValues}
                value={charge.status}
                name="status"
                notched={true}
                inputProps={{
                  name: "status",
                  id: "outlined-select-estado",
                }}
              >
                <MenuItem
                  className={classes.menuItem}
                  key="ACTIVO"
                  value="Activo"
                >
                  Activo
                </MenuItem>
                <MenuItem
                  className={classes.menuItem}
                  key="INACTIVO"
                  value="Inactivo"
                >
                  Inactivo
                </MenuItem>
              </Select>
              <FormHelperText>
                {errors.hasOwnProperty("status") && errors["status"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={2} style={{ marginTop: 15 }}>
            <Button
              variant="outlined"
              style={{ backgroundColor: "transparent", color: "#7EBDCE" }}
              onClick={cancelConfirm}
            >
              CANCELAR
            </Button>
            &nbsp;&nbsp;
            <Button
              style={{
                backgroundColor: "#7EBDCE",
                color: "#ffffff",
                border: "1px solid #e4e1e1 !important",
              }}
              type="submit"
              disabled={onsubmitDisabled}
            >
              {" "}
              EDITAR
            </Button>
            &nbsp;&nbsp;
          </Grid>
          <ModalConfirm
            description={message.description}
            textButtonSubmit={message.textButtonSubmit}
            handleClick={message.handleClick}
            handleClickOut={message.handleClickOut}
            oneButtons={message.oneButtons}
            type={message.type}
            open={message.open}
          />
        </Grid>
      </form>
    </>
  );
};

export default withRouter(Charges);
